const handleRoute = async (action) => {
    if (action.route.charAt(0) === '#') {
        const route = action.route.substr(1);

        AppKit.getApp().$router.push({ path: route });
    }
    else window.open(action.route, action.target);
};

const addGlobalMessage = (message) => {
    AppKit.getApp().globalMessages.push({
        show: true,
        text: message,
    });
};

const removeGlobalMessage = (message) => {
    AppKit.getApp().globalMessages = AppKit.getApp().globalMessages.filter(el => el.text != message.text);
};

const handleEvent = async (action, component) => {
    component.$emit(action.eventName, action.eventData);
};

// Creates a promise that resolves after executing actions
const handleActions = async (actions, component) => {
    // Function should never be called without actions, but still check for it.
    if (actions.length === 0) return;

    // Globally execute global functions (route and message)
    actions.filter(x => x.type !== 'refresh').forEach(async action => {
        switch (action.type) {
            case 'route':
                await handleRoute(action);
                break;
            case 'message':
                await addGlobalMessage(action.title);
                break;
            case 'event':
                await handleEvent(action, component);
                break;
            default:
                break;
        }
    });

    // Return the actions that need to be performed within the component (refresh for now)
    return actions.filter(x => x.type === 'refresh');
}

const actionHandler = {
    install: (Vue) => {
        Vue.prototype.$handleActions = async (actions, component) => handleActions(actions, component);
        Vue.prototype.$removeGlobalMessage = async (actions) => removeGlobalMessage(actions);
        Vue.prototype.$addGlobalMessage = async (actions) => addGlobalMessage(actions);
    }
}

export default actionHandler;